
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { api } from '../api';


function Customers() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const fetchCustomers = async (pageNum = page, limitNum = perPage) => {
    setLoading(true);
    setError(null);
    const res = await api.getCustomers(pageNum, limitNum);
    if (res.error) {
      setError(res.error);
      setCustomers([]);
      setTotalRows(0);
    } else {
      setCustomers(res.users);
      setTotalRows(res.total);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCustomers(page, perPage);
    // eslint-disable-next-line
  }, [page, perPage]);

  const handlePageChange = pageNum => setPage(pageNum);
  const handlePerRowsChange = async (newPerPage, pageNum) => {
    setPerPage(newPerPage);
    setPage(pageNum);
  };

  const columns = [
    {
      name: 'Profile',
      selector: row => <img className="vendor-thumb" src={row.profileImage || '/assets/img/vendor/u9.jpg'} alt="user profile" />, width: '80px',
    },
    { name: 'Name', selector: row => row.fullName || row.firstName || '-', sortable: true },
    { name: 'Email', selector: row => row.email || '-', sortable: true },
    { name: 'Phone', selector: row => row.phone || '-', sortable: true },
    { name: 'Total Buy', selector: row => row.totalBuy || '-', sortable: true },
    { name: 'Orders', selector: row => row.ordersCount || '-', sortable: true },
    { name: 'Last Login', selector: row => row.lastLogin ? new Date(row.lastLogin).toLocaleDateString() : '-', sortable: true },
    { name: 'Status', selector: row => <span className={`ec-status ${row.status === 'Active' ? 'ec-active' : 'ec-inactive'}`}>{row.status || '-'}</span>, sortable: true },
    { name: 'Join On', selector: row => row.createdAt ? new Date(row.createdAt).toLocaleDateString() : '-', sortable: true },
    {
      name: 'Action',
      cell: row => (
        <div className="btn-group mb-1">
          <button type="button" className="btn btn-outline-success" onClick={() => navigate(`/customers/${row.id}`)}>Info</button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Customers | Owena Admin Dashboard</title>
      </Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Customers</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={e => e.preventDefault()}>Home</a></span>
                <span><i className="mdi mdi-chevron-right"></i></span>Customers</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  <DataTable
                    columns={columns}
                    data={customers}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    highlightOnHover
                    responsive
                    noHeader
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Customers;
